import { render, staticRenderFns } from "./SmileFaceIcon.vue?vue&type=template&id=9795a276&"
import script from "./SmileFaceIcon.vue?vue&type=script&lang=ts&"
export * from "./SmileFaceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports